import pricing, { pricingInverse as pricingInverseAll, metadata as metadataAll } from '../core/pricings/v6/pricings';

export default pricing;

export const pricingInverse = pricingInverseAll;
export const metadata = metadataAll;
